import { HashLink } from "../../../../src/components/link";
import researchGraphic from "../../../../src/images/teleworker-career-satisfaction.png";
import * as React from 'react';
export default {
  HashLink,
  researchGraphic,
  React
};